module.exports = __webpack_public_path__ + "static/media/black-cat-win.24dd076e.png";